export default {
  sku: 'GA17',
  common: {
    features: [
      'Higher email sending limit per day',
      'Remove Email Studio watermark from emails',
      'Send emails on a recurring schedule',
      'Copy drafts in Gmail',
      'Forward emails to external addresses',
      'Send auto-replies for both new and old emails',
      'Unsubscribe from Mailing Lists',
      'Auto-purge old emails',
    ],
  },
  standard: {
    name: 'Standard',
    price: '79.95',
    features: ['Complimentary email support for 30 days'],
  },
  enterprise: {
    name: 'Enterprise',
    price: '99.95',
    features: [
      'Priority email support while subscribed',
      'One-on-one support (2 calls per annual billing cycle)',
    ],
  },
};
